import * as React from 'react';

const SvgIcnChevron = (props) => (
  <svg viewBox="0 0 32 32" {...props}>
    <path d="M10.178 31.2c-.686 0-1.143-.229-1.6-.686-.914-.914-.914-2.286 0-3.2l11.2-11.2-11.2-11.429c-.914-.914-.914-2.286 0-3.2s2.286-.914 3.2 0l14.629 14.63-14.63 14.628c-.228.23-.913.457-1.6.457z" />
  </svg>
);

export default SvgIcnChevron;
